import React, { useContext, useState } from 'react';

import { ApiRoutes, FetchContext, HttpMethods, ToastContext } from '../../contexts';

import { useAggregatedState } from '../../../helpers';

export const StoricoUfficioContext = React.createContext(null);

const { Provider } = StoricoUfficioContext;

export const StoricoUfficioProvider = (props) => {
    const {
        showWarningMessage,
        showSuccessMessage,
        showErrorMessage
    } = useContext(ToastContext);
    const { fetchOk, fetchAuthorized } = useContext(FetchContext);
    const [state, setState] = useAggregatedState({
        storicoUfficio: null,
    });

    const {
    } = state;

    const [isLoadingStoricoUfficio, setIsLoadingStoricoUfficio] = useState(false);
    const getStoricoUfficioAsync = async (ufficioId, storicoId) => {
        try {
            setIsLoadingStoricoUfficio(true);
            const r = await fetchAuthorized(ApiRoutes.Ufficio.GetStorico({ ufficioId, storicoId }), {
                method: HttpMethods.GET
            });
            const result = await r.json();
            result.dataCreazione = new Date(result.dataCreazione);
            result.valore = JSON.parse(result.valore);
            result.valore.Contatti = result.valore.Contatti.map(e => { return { ...e, InizioValidita: new Date(e.InizioValidita), FineValidita: e.FineValidita ? new Date(e.FineValidita) : null, } });
            result.valore.Contatti.forEach(e => {
                e.Contatti = e.Contatti.map(e => { return { ...e, InizioValidita: new Date(e.InizioValidita), FineValidita: e.FineValidita ? new Date(e.FineValidita) : null, } });
            });

            if(result.valorePrecedente != null && result.valorePrecedente){
                result.valorePrecedente = JSON.parse(result.valorePrecedente);
                result.valorePrecedente.Contatti = result.valorePrecedente.Contatti.map(e => { return { ...e, InizioValidita: new Date(e.InizioValidita), FineValidita: e.FineValidita ? new Date(e.FineValidita) : null, } });
            result.valorePrecedente.Contatti.forEach(e => {
                e.Contatti = e.Contatti.map(e => { return { ...e, InizioValidita: new Date(e.InizioValidita), FineValidita: e.FineValidita ? new Date(e.FineValidita) : null, } });
            });
            }



            setState({ storicoUfficio: result });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingStoricoUfficio(false);
        }
    }

    return (
        <Provider value={{
            state,
            setState,

            isLoadingStoricoUfficio,
            getStoricoUfficioAsync,
        }}>
            {props.children}
        </Provider>
    );
}